import React, { useState, useEffect } from 'react';

const UploadImage = (props) => {
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [description, setDescription] = useState('');
  const [uploadedPageUrl, setUploadedPageUrl] = useState('');
  const [email, setEmail] = useState('');
  const [balance, setBalance] = useState(0);
  const [error, setError] = useState('');

  const COST_PER_ACTION = 50;

  useEffect(() => {
    const state = props.location?.state;
    if (state?.email && state.balance !== undefined) {
      setEmail(state.email);
      setBalance(state.balance);
    } else {
      fetchUserData();
    }
  }, []);

  const fetchUserData = async () => {
    try {
      const res = await fetch('/user-details');
      const data = await res.json();
      setEmail(data.email);
      setBalance(data.balance);
    } catch (err) {
      console.error('Error fetching user data', err);
      setError('Failed to fetch user data');
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!imageFile || !description) {
      alert('Please upload an image and enter a description.');
      return;
    }

    if (balance < COST_PER_ACTION) {
      alert("You don't have enough credits to upload this image.");
      return;
    }

    const confirmed = window.confirm(`Confirm upload? This will deduct ${COST_PER_ACTION} credits.`);
    if (!confirmed) return;

    const formData = new FormData();
    formData.append('image', imageFile);
    formData.append('description', description);

    try {
      const response = await fetch('/upload-image', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error('Upload failed');

      const data = await response.json();
      const viewUrl = `/view/${data.id}`;
      setUploadedPageUrl(viewUrl);

      // Update balance after upload
      const newBalance = balance - COST_PER_ACTION;
      await fetch('/update-balance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newBalance }),
      });
      setBalance(newBalance);

      // Reset form fields
      setImageFile(null);
      setImagePreview(null);
      setDescription('');
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Upload failed.');
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Upload Image and Description</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div style={{ marginBottom: '10px' }}>
        Email: {email || 'Loading...'} | Balance: {typeof balance === 'number' ? balance.toFixed(2) : 'Loading...'} credits
      </div>
      <form onSubmit={handleSubmit}>
        <input
          type="file"
          accept="image/jpeg, image/png"
          onChange={handleImageChange}
          style={{ display: 'block', marginBottom: '10px' }}
        />
        {imagePreview && (
          <div style={{ marginBottom: '10px' }}>
            <img src={imagePreview} alt="Preview" style={{ width: '100%', maxWidth: '400px' }} />
          </div>
        )}
        <textarea
          rows="4"
          cols="60"
          placeholder="Enter image description..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{ display: 'block', marginBottom: '10px' }}
        />
        <button type="submit">Upload</button>
      </form>

      {uploadedPageUrl && (
        <div style={{ marginTop: '30px' }}>
          <a href={uploadedPageUrl} target="_blank" rel="noopener noreferrer">
            View Uploaded Image Page
          </a>
        </div>
      )}
    </div>
  );
};

export default UploadImage;
